/**
 * Nomes das permissões do sistema.
 * Centraliza os identificadores para evitar strings soltas no código.
 */
export const PERMISSIONS = {
  /** Gerenciar subparóquias (criar, editar, excluir) */
  MANAGE_SUBPARISHES: 'manage_subparishes',
  /** Solicitar saque antecipado antes do evento */
  REQUEST_EARLY_WITHDRAWAL: 'request_early_withdrawal',
  // Adicione novas permissões aqui conforme o sistema crescer
} as const;

export type PermissionKey = keyof typeof PERMISSIONS;
export type Permission = (typeof PERMISSIONS)[PermissionKey];
